import CantileverCard from 'components/CantileverCard'
import dayjs from 'dayjs'
import { useGetUserMetadata } from 'features/rolodex'
import { InfoLabel, InfoRow } from 'features/walkdowns'
import React, { useMemo } from 'react'
import { GeckoWalkdown } from 'types'

interface WalkdownBasicInfoProps {
  walkdown: GeckoWalkdown
}

export const WalkdownBasicInfo: React.FC<WalkdownBasicInfoProps> = ({
  walkdown,
}) => {
  const formattedStartDate = useMemo(() => {
    const start_date = walkdown?.data?.startDate
    if (!start_date) return ''
    return dayjs(start_date).format('MMMM D, YYYY')
  }, [walkdown])

  const leadId = walkdown?.data?.lead
  const { data: walkdownUserMetadata } = useGetUserMetadata(leadId as string)

  const leadName = !leadId
    ? ''
    : walkdownUserMetadata
      ? walkdownUserMetadata.name || walkdownUserMetadata.email || leadId
      : leadId

  const poc = walkdown?.data.pointOfContact

  return (
    <CantileverCard>
      <CantileverCard.CardHeader leadingContent='Basic Information' />
      <CantileverCard.Section topPadding>
        <CantileverCard.Group>
          <InfoRow>
            <InfoLabel>Start Date:</InfoLabel>
            <span>{formattedStartDate}</span>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Lead:</InfoLabel>
            <span>{leadName ? String(leadName) : 'N/A'}</span>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Point of Contact:</InfoLabel>
            <span>{poc ? poc.name : 'N/A'}</span>
            {poc?.phoneNumber && <span>{poc.phoneNumber}</span>}
          </InfoRow>
        </CantileverCard.Group>
      </CantileverCard.Section>
    </CantileverCard>
  )
}
